/**
 * filter-lists.js
 * Common functionality for filtering lists dynamically on the front-end.
 * Examples: On Demand and Session event tabs.
 */

/* eslint-disable camelcase */

/**
 * Add or remove the no results message.
 *
 * @param {boolean} visible The state of the "no results" message: true = visible | false = hidden.
 * @param {object}  container The container element the "no results" message should be appended to.
 */
function toggleNoResults( visible, container ) {
	if ( ! container ) {
		return;
	}

	const noResults = document.getElementById( 'filter-list-form-no-results' );

	// No results but no message.
	if ( visible && ! noResults ) {
		const noResults = document.createElement( 'p' );
		noResults.setAttribute( 'id', 'filter-list-form-no-results' );
		noResults.textContent = window.MSR_i18n.onDemand.noResults;
		container.appendChild( noResults );
	} 
	
	if ( ! visible && noResults ) {
		noResults.remove();
	}
}

/**
 * Serialize all form data into an object
 * Modified from Chris Ferdinandi https://gomakethings.com
 * @param  {Node} form The form to serialize
 * @return {String}    The serialized form data
 */
function serialize ( form ) {
	const data = new FormData( form );
	const obj = {};
	for ( const [key, value] of data ) {
		if ( obj[key] !== undefined ) {
			if ( !Array.isArray( obj[key] ) ) {
				obj[key] = [obj[key]];
			}
			obj[key].push( value );
		} else {
			obj[key] = value;
		}
	}
	return obj;
}

export { toggleNoResults, serialize };
